import { Component, OnDestroy } from '@angular/core';

import { Plugins, StatusBarStyle } from "@capacitor/core";
import { AlertController, LoadingController, MenuController, NavController, Platform } from '@ionic/angular';
import { BotonPanico, Usuario } from './interfaces/book.interface';
import { AuthService } from './services/auth.service';
import { FirebaseService } from './services/firebase.service';
import { NotificacionesService } from './services/notificaciones.service';
import { ToastService } from './services/toast.service';
import { Insomnia } from '@ionic-native/insomnia/ngx';
import { Subscription } from 'rxjs';

const { Geolocation } = Plugins;

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnDestroy {

  private subscriptionUser: Subscription = new Subscription();
  private subscriptionPanico: Subscription = new Subscription();

  user: Usuario = {
    rol: null,
    // cc: null,
    nombre: '',
    email: '',
    celular: '',
    // nacimiento: null,
    ciudad: null,
    estado: null,
    // sexo: null,
  };

  btnPanico = {
    estado: true,
    color: 'panico-off'
  }

  userBtnPanico: BotonPanico;

  constructor(
    private platform: Platform,
    private menu: MenuController,
    private firebase: FirebaseService,
    private auth: AuthService,
    private loadingCtrl: LoadingController,
    private toast: ToastService,
    public navCtrl: NavController,
    private notificaciones: NotificacionesService,
    private insomnia: Insomnia,
    public alertController: AlertController
  ) {

    this.initializeApp();

    this.subscriptionUser.add(this.auth.getUidState().subscribe(user => {
      if (user !== null && user !== undefined) {
        const uid = user.uid;
        console.log('User id ->', uid);
        const path = '/usuarios/' + user.uid;
        this.firebase.getDoc<Usuario>(path).subscribe(async data => {
          console.log('User data->', data);
          this.user = data;
          if (this.user.rol === 'cliente' ||
            this.user.rol === 'transportador' ||
            this.user.rol === 'comercio' ||
            this.user.rol === 'propietario') {
            this.loadBotonPanico();
          }
          this.subscriptionUser.unsubscribe();
        });
      } else {
        this.user = {
          rol: null,
          // cc: null,
          nombre: '',
          email: '',
          celular: '',
          // nacimiento: null,
          ciudad: null,
          estado: null,
          // sexo: null,
        };
      }
    }));
  }

  ngOnDestroy() {
    this.firebase;
    this.auth;
    this.user;
    this.subscriptionPanico.unsubscribe();
    this.subscriptionUser.unsubscribe();
  }

  /* Nav Admin */
  navAdminDashboard() {
    this.menu.close('custom');
    this.navCtrl?.navigateRoot('/admin-dashboard');
  }

  navAdminWebServices() {
    this.menu.close('custom');
    this.navCtrl?.navigateRoot('/admin-webservice');
  }

  navAdminCentral() {
    this.menu.close('custom');
    this.navCtrl?.navigateRoot('/admin-central');
  }

  navAdminCliente() {
    this.menu.close('custom');
    this.navCtrl?.navigateRoot('/admin-clientes');
  }

  navAdminPropietario() {
    this.menu.close('custom');
    this.navCtrl?.navigateRoot('/admin-propietarios');
  }

  navAdminTransportador() {
    this.menu.close('custom');
    this.navCtrl?.navigateRoot('/admin-transportadores');
  }

  navAdminComercio() {
    this.menu.close('custom');
    this.navCtrl?.navigateRoot('/admin-comercios');
  }

  /* Nav Propietario */
  navPropietarioDashboard() {
    this.menu.close('custom');
    this.navCtrl?.navigateRoot('/propietario-dashboard');
  }
  navPropietarioVehiculo() {
    this.menu.close('custom');
    this.navCtrl?.navigateRoot('/propietario-vehiculos');
  }
  navPropietarioCentral() {
    this.menu.close('custom');
    this.navCtrl?.navigateRoot('/propietario-central');
  }

  /* Nav Transportador */
  navTransportadorDashboard() {
    this.menu.close('custom');
    this.navCtrl?.navigateRoot('/transportador-dashboard');
  }
  navTransportadorVehiculo() {
    this.menu.close('custom');
    this.navCtrl?.navigateRoot('/transportador-vehiculo');
  }
  navTransportadorEncargas() {
    this.menu.close('custom');
    this.navCtrl?.navigateRoot('/transportador-encargas');
  }
  navTransportadorEncargasPost() {
    this.menu.close('custom');
    this.navCtrl?.navigateRoot('/transportador-encargas-post');
  }
  navTransportadorAdicional() {
    this.menu.close('custom');
    this.navCtrl?.navigateRoot('/transportador-adicional');
  }
  navTransportadorCentral() {
    this.menu.close('custom');
    this.navCtrl?.navigateRoot('/transportador-central');
  }

  /* Nav Comercio */
  navComercioDashboard() {
    this.menu.close('custom');
    this.navCtrl?.navigateRoot('/comercio-dashboard');
  }
  navComercioPedidos() {
    this.menu.close('custom');
    this.navCtrl?.navigateRoot('/comercio-pedidos');
  }
  navComercioEncargas() {
    this.menu.close('custom');
    this.navCtrl?.navigateRoot('/comercio-encargas');
  }
  navComercioProductos() {
    this.menu.close('custom');
    this.navCtrl?.navigateRoot('/comercio-productos');
  }
  navComercioCentral() {
    this.menu.close('custom');
    this.navCtrl?.navigateRoot('/comercio-central');
  }

  /* Nav Cliente */
  navClienteDashboard() {
    this.menu.close('custom');
    this.navCtrl?.navigateRoot('/cliente-dashboard');
  }
  navClienteEncargas() {
    this.menu.close('custom');
    this.navCtrl?.navigateRoot('/cliente-encargas');
  }
  navClientePedidos() {
    this.menu.close('custom');
    this.navCtrl?.navigateRoot('/cliente-pedidos');
  }
  navClienteCentral() {
    this.menu.close('custom');
    this.navCtrl?.navigateRoot('/cliente-central');
  }

  /* Default */
  navTerminos() {
    this.menu.close('custom');
    this.navCtrl?.navigateRoot('/terminos');
  }

  async navLogout() {
    const loading = await this.loadingCtrl.create({
      message: 'Cerrando sesión...',
      spinner: 'crescent',
      showBackdrop: true
    });

    this.menu.close('custom');
    loading.present();

    this.auth.logout().then(res => {
      this.user = {
        rol: null,
        // cc: null,
        nombre: '',
        email: '',
        celular: '',
        // nacimiento: null,
        ciudad: null,
        estado: null,
        // sexo: null,
      };

      loading.dismiss();
      this.navCtrl?.navigateRoot('/login');
    }).catch(error => {
      loading.dismiss();
      this.toast.msgAppTop(error, 'danger');
    });
  }

  async initializeApp() {
    const { SplashScreen, StatusBar } = Plugins;
    try {
      await SplashScreen.hide();
      await StatusBar.setStyle({ style: StatusBarStyle.Light });
      if (this.platform.is('android')) {
        StatusBar.setBackgroundColor({ color: '#CDCDCD' });
      }
      if (this.platform.is('capacitor')) { // ¿Movile?
        this.insomnia.keepAwake().then(() => {
          console.log('Bloquedo de Pantalla -> Activo');
        }).catch(err => {
          console.log('Bloquedo de Pantalla', err);
        });
      }
    } catch (error) {
      console.log('This is normal in a browser', error);
    }
  }

  loadBotonPanico() {
    const path = '/boton_panico/' + this.user.id;
    this.subscriptionPanico.add(
      this.firebase.getDoc<BotonPanico>(path).subscribe(async data => {
        console.log('Boton panico data->', data);
        if (data === undefined) {
          this.btnPanico.color = 'panico-off';
          this.btnPanico.estado = true;
        } else {
          this.btnPanico.color = 'panico-on';
          this.btnPanico.estado = false;
        }
        this.subscriptionPanico.unsubscribe();
      })
    );
  }

  async botonPanico() {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: 'Botón de pánico',
      message: '¿Está seguro de activar?',
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            console.log('Confirm Cancel: blah');
          }
        }, {
          text: 'Confirmar',
          handler: () => {
            console.log('Confirm Okay');
            this.goBotonPanico();
          }
        }
      ]
    });

    await alert.present();
  }

  goBotonPanico() {
    if (this.btnPanico.estado) {
      console.log('botonPanico activado...');
      Geolocation.getCurrentPosition().then((res) => {

        const dataPanico: BotonPanico = {
          id: this.user.id,
          usuario: this.user,
          ubicacion: {
            lat: res.coords.latitude,
            lng: res.coords.longitude
          },
          createdAt: Date.now()
        }
        const path = '/boton_panico/';
        this.firebase.createDoc(dataPanico, path, dataPanico.id).then(() => {
          this.btnPanico.color = 'panico-on';
          this.btnPanico.estado = false;
          this.toast.msgAppTop('¡Botón de pánico activado!', 'success');
        }).catch(error => {
          this.toast.msgAppTop(error.message, 'danger');
        });

      });
    } else {
      console.log('botonPanico On...');
    }
  }

  goToLink(url: string) {
    window.open(url, "_blank");
  }


}
